/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { DeleteCourseActivityOptions, DeleteCourseActivityStatus200, DeleteCourseActivityStatus422 } from '../models/DeleteCourseActivity'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { deleteCourseActivity } from '../clients/axios/deleteCourseActivity'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const deleteCourseActivityMutationKey = () => [{ url: '/admin/course/activity/:activity_id' }] as const

export function deleteCourseActivityMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = deleteCourseActivityMutationKey()
  return mutationOptions<DeleteCourseActivityStatus200, ResponseErrorConfig<DeleteCourseActivityStatus422>, DeleteCourseActivityOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return await deleteCourseActivity({ ...config, path, throwOnError: true })
    },
  })
}

/**
 * @summary Delete Course Activity
 * {@link /admin/course/activity/:activity_id}
 */
export function useDeleteCourseActivity<TContext>(options: {
  mutation?: UseMutationOptions<DeleteCourseActivityStatus200, ResponseErrorConfig<DeleteCourseActivityStatus422>, DeleteCourseActivityOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteCourseActivityMutationKey()

  const baseOptions = deleteCourseActivityMutationOptions(config) as UseMutationOptions<DeleteCourseActivityStatus200, ResponseErrorConfig<DeleteCourseActivityStatus422>, DeleteCourseActivityOptions, TContext>

  return useMutation<DeleteCourseActivityStatus200, ResponseErrorConfig<DeleteCourseActivityStatus422>, DeleteCourseActivityOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<DeleteCourseActivityStatus200, ResponseErrorConfig<DeleteCourseActivityStatus422>, DeleteCourseActivityOptions, TContext>
}
